<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-10-21 13:50:12
-->
<template>
  <div class="content-wrap">
    <!-- 育苗 -->
    <div
      class="container-ym"
      style="width: 100%"
    >
      <!-- 内容盒子 -->
      <OverviewTab>
        <div class="content-box">
          <!-- 左边盒子 -->
          <div class="left-box">
            <!-- 上 -->
            <div class="top-box">
              <el-carousel
                :interval="10000"
                height="136px"
                indicator-position="none"
                arrow="always"
              >
                <el-carousel-item
                  v-for="(item, idx) in carouselData"
                  :key="idx"
                >
                  <!-- 一批次销售产值 -->
                  <div>
                    <div>
                      <div class="text">
                        <p>
                          <img
                            src="../../../../assets/img/middle/销售产值.png"
                            alt=""
                          />
                        </p>
                        <p>
                          <CountIn
                            :startVal="0"
                            :endVal="item.saleMoney"
                            :speed="800"
                            :decimals="2"
                            :isReverse="item.saleMoney >= 0 ? false : true"
                            :noAnimation="false"
                          />
                        </p>
                        <p>{{ item.seedlingDataName }}销售产值/万元</p>
                      </div>
                      <div class="num-text">
                        <div>
                          <p>环比&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                          <p>
                            <span>{{ item.saleMoneyPerCent }}%</span>
                            <span>
                              <img
                                v-show="item.saleMoneyPerCent > 0"
                                src="../../../../assets/img/middle/上.png"
                                alt=""
                              />
                              <img
                                v-show="item.saleMoneyPerCent < 0"
                                src="../../../../assets/img/middle/下.png"
                                alt=""
                              />
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </p>
                        </div>
                        <div>
                          <p>上一批次</p>
                          <p>
                            <span>{{ item.saleMoneyLast }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 一批次收获总产量 -->
                  <div>
                    <div>
                      <div class="text">
                        <p>
                          <img
                            src="../../../../assets/img/middle/收货总产量.png"
                            alt=""
                          />
                        </p>
                        <p>
                          <CountIn
                            :startVal="0"
                            :endVal="item.harvestYield"
                            :speed="800"
                            :decimals="2"
                            :isReverse="item.harvestYield >= 0 ? false : true"
                            :noAnimation="false"
                          />
                        </p>
                        <p>{{ item.seedlingDataName }}收获总产量/万尾</p>
                      </div>
                      <div class="num-text">
                        <div>
                          <p>环比&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                          <p>
                            <span>{{ item.harvestYieldPerCent }}%</span>
                            <span>
                              <img
                                v-show="item.harvestYieldPerCent > 0"
                                src="../../../../assets/img/middle/上.png"
                                alt=""
                              />
                              <img
                                v-show="item.harvestYieldPerCent < 0"
                                src="../../../../assets/img/middle/下.png"
                                alt=""
                              />
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </p>
                        </div>
                        <div>
                          <p>上一批次</p>
                          <p>
                            <span>{{ item.harvestYieldLast }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <!-- 中 -->
            <div class="center-box">
              <div>
                <div>
                  <span></span>
                  <span>* 各批次收获情况</span>
                </div>
                <div class="right-center-table">
                  <el-table
                    :header-cell-style="{
                      background: '#1E1E2B',
                      color: '#FFFFFF',
                      borderColor: '#46494a',
                      textAlign: 'left',
                    }"
                    height="322px"
                    :data="tableOneData"
                  >
                    <el-table-column
                      prop="seedlingDataName"
                      label="育苗批次"
                    ></el-table-column>
                    <el-table-column
                      prop="harvestBoxNum"
                      label="收获塘口数"
                    ></el-table-column>
                    <el-table-column
                      prop="harvestYield"
                      label="收获产量/万尾"
                    ></el-table-column>
                    <el-table-column
                      prop="saleMoney"
                      label="销售产值/万元"
                    ></el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <!-- 下 -->
            <div class="bottom-box">
              <div class="two-box">
                <div>
                  <span></span>
                  <span>* 各批次育苗天数与投入成本</span>
                  <span class="check">
                    <RouteTarget :pathName="'day-ym-seedling-details'">
                      <span class="check">查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
                    </RouteTarget>
                  </span>
                </div>
                <!-- 一批次各品种育苗天数与投入成本图表charts -->
                <div
                  id="dateCostCharts"
                  ref="dateCostCharts"
                ></div>
              </div>
            </div>
          </div>
          <!-- 右边盒子 -->
          <div class="right-box">
            <!-- 上 -->
            <div class="top-box">
              <div>
                <div>
                  <span></span>
                  <span>各批次投卵情况</span>
                </div>
                <!-- table -->
                <span class="table-box">
                  <p
                    class="table-one-box"
                    @mouseover="clearBreedEggScroll()"
                    @mouseleave="setBreedEggScroll()"
                  >
                    <el-table
                      :header-cell-style="{
                        background: '#1E1E2B',
                        color: '#FFFFFF',
                        borderColor: '#46494a',
                      }"
                      height="235px"
                      :data="tableTwoData"
                      ref="breedEggTable"
                    >
                      <el-table-column
                        prop="seedlingDataName"
                        label="育苗批次"
                      ></el-table-column>
                      <el-table-column
                        prop="putNumber"
                        label="投卵量/公斤"
                      ></el-table-column>
                      <el-table-column
                        prop="putBoxNum"
                        label="投卵塘口数/口"
                      ></el-table-column>
                    </el-table>
                  </p>
                </span>
              </div>
              <div>
                <div>
                  <span></span>
                  <span @click="isShowChartClick('table-one-box')">各批次饲料使用情况 (总量：{{
                      UseOfABatchOfFeedNum
                    }}{{fodderKgToJin}})</span>
                </div>
                <!-- table -->
                <span class="table-box">
                  <p
                    class="table-two-box"
                    style="padding-right: 0"
                    @mouseover="clearFeedUseScroll1()"
                    @mouseleave="setFeedUseScroll1()"
                  >
                    <el-table
                      :header-cell-style="{
                        background: '#1E1E2B',
                        color: '#FFFFFF',
                        borderColor: '#46494a',
                        textAlign: 'left',
                      }"
                      height="235px"
                      :data="tableThreeData.fodderTypeData"
                      ref="feedUseTable1"
                      style="padding-right: 10px"
                    >
                      <el-table-column
                        prop="seedlingDataName"
                        label="育苗批次"
                      ></el-table-column>
                      <el-table-column
                        prop="fodderType"
                        label="饲料品类"
                      ></el-table-column>
                      <el-table-column
                        prop="fodderWeight"
                        label="总投料量"
                      ></el-table-column>
                    </el-table>
                  </p>
                  <p
                    class="table-two-box"
                    @mouseover="clearFeedUseScroll2()"
                    @mouseleave="setFeedUseScroll2()"
                  >
                    <el-table
                      :header-cell-style="{
                        background: '#1E1E2B',
                        color: '#FFFFFF',
                        borderColor: '#46494a',
                      }"
                      height="235px"
                      :data="tableThreeData.fodderWeight"
                      ref="feedUseTable2"
                    >
                      <el-table-column
                        prop="seedlingDataName"
                        label="育苗批次"
                      ></el-table-column>
                      <el-table-column
                        prop="fodderWeight"
                        label="总投料量"
                      ></el-table-column>
                    </el-table>
                  </p>
                </span>
              </div>
            </div>
            <!-- 中 -->
            <div class="center-box">
              <div>
                <div>
                  <span></span>
                  <span @click="isShowChartClick('DailyFeedCharts')">饲料日投喂 (今日总量{{ DailyFeedNum }}{{fodderKgToJin}})</span>
                </div>
                <!-- table -->
                <div
                  id="PrivateChatCharts"
                  ref="PrivateChatCharts"
                ></div>
              </div>
              <div>
                <div>
                  <span></span>
                  <span @click="isShowChartClick('PrivateChatExistingCharts')">饲料现存量</span>
                  <span class="check">
                    <RouteTarget :pathName="'day-ym-feed'">
                      <span class="check">查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
                    </RouteTarget>
                  </span>
                </div>
                <!-- 饲料日投喂charts -->
                <div
                  id="PrivateChatExistingCharts"
                  ref="PrivateChatExistingCharts"
                ></div>
              </div>
            </div>
            <!-- 下 -->
            <div class="bottom-box">
              <div>
                <div>
                  <span></span>
                  <span @click="isShowChartClick('dayDynamicProtectionCharts')">动保日投用 (今日总金额：{{ DailyBasisNum }}元)</span>
                </div>
                <!-- 动保日投用charts -->
                <div
                  id="dayDynamicProtectionCharts"
                  ref="dayDynamicProtectionCharts"
                ></div>
              </div>
              <div>
                <div>
                  <span></span>
                  <span @click="isShowChartClick('SaveDynamicProtectionCharts')">动保现存量</span>
                  <span class="check">
                    <RouteTarget :pathName="'day-ym-drug'">
                      <span class="check">查看更多<i class="iconfont icon-a-PresidentDesktop-Viewmore"></i></span>
                    </RouteTarget>
                  </span>
                </div>
                <!-- 动保现存量charts -->
                <div
                  id="SaveDynamicProtectionCharts"
                  ref="SaveDynamicProtectionCharts"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <el-dialog
          width="80%"
          @close="isShowChartClose"
          class="show-chart-box"
          :visible.sync="isShowChart"
        >
          <span class="show-chart-title">{{ showChart.title }}</span>
          <div class="type_btn_container">
            <span
              @click="isShowChartTypeClick(showChart.chartType, item.id)"
              v-bind:class="{
                'sub-active': showChart.searchType == item.id,
              }"
              :key="index"
              v-for="(item, index) in showChart.targetCategory"
            >
              {{ item.name }}
            </span>
          </div>
          <div
            class="cancel-delete"
            @click="isShowChart = false"
          ></div>
          <div
            class="chart-content"
            v-if="!isShowTable"
            ref="chart_vm"
            id="chart_vm"
          ></div>
          <span
            class="show-chart-table-box"
            v-else-if="isShowTable"
          >
            <div class="two-table-content">
              <p
                class="table-two-box"
                style="padding-right: 0"
              >
                <el-table
                  :header-cell-style="{
                    background: 'rgba(15,14,25)',
                    color: '#FFFFFF',
                    borderColor: '#46494a',
                    textAlign: 'left',
                  }"
                  :data="tableThreeData.fodderTypeData"
                  style="padding-right: 10px"
                >
                  <el-table-column
                    prop="seedlingDataName"
                    label="育苗批次"
                  ></el-table-column>
                  <el-table-column
                    prop="fodderType"
                    label="饲料品类"
                  ></el-table-column>
                  <el-table-column
                    prop="fodderWeight"
                    label="总投料量"
                  ></el-table-column>
                </el-table>
              </p>
              <p class="table-two-box">
                <el-table
                  :header-cell-style="{
                    background: 'rgba(15,14,25)',
                    color: '#FFFFFF',
                    borderColor: '#46494a',
                  }"
                  :data="tableThreeData.fodderWeight"
                >
                  <el-table-column
                    prop="seedlingDataName"
                    label="育苗批次"
                  ></el-table-column>
                  <el-table-column
                    prop="fodderWeight"
                    label="总投料量"
                  ></el-table-column>
                </el-table>
              </p>
            </div>
          </span>
        </el-dialog>
      </OverviewTab>
    </div>
  </div>
</template>

<script>
import * as $echarts from "echarts";
import Page from "@/utils/methods/page";
import service from "../../../../api/middle/day/ym-service";
import OverviewTab from "@/components/pc/overview-tab.vue";
import RouteTarget from "@/components/pc/route-target.vue";
import CountIn from "@/components/pc/count-in.vue";
import debounce from "@/utils/debounce";
import BaiduCustomeMap from "@/components/pc/baidu-map/baidu-custome-map.vue";
import {listParamStatus} from "@/api/general.js"
export default {
  name: "ym",
  inject: ["app"],
  components: {
    OverviewTab,
    RouteTarget,
    CountIn,
    BaiduCustomeMap,
  },
  props: {
    date: "",
    dateType: "",
  },
  data() {
    return {
      // 放大查看table表格
      isShowTable: false,
      // 判断饲料现存量和动保现存量的存储对象
      feedDefaultNum: null,
      // 放大查看图表参数对象
      showChart: {
        chartType: "",
        title: "",
        idName: "chart_vm",
        searchType: "",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
        targetCategory: [],
      },
      isShowChart: false, //放大查看图表（报表）数据
      DailyFeedNum: 0, //饲料日投喂今日总量
      UseOfABatchOfFeedNum: 0, //一批次饲料使用情况今日总量
      DailyBasisNum: 0, //动保日投用今日总量
      orgId: localStorage.getItem("orgId"), // 一级机构
      type: "", // 时间类型(Y: 年, M: 年月)
      year: "", // 年份(yyyy)
      month: "", // 年月(yyyy-MM)
      breedTypeClass: "egg", // 阶段类型（egg：育苗，fish：养成）
      // 一批次各品种收获情况
      tableOneData: [],
      // 一批次各品种投卵情况
      tableTwoData: [],
      // 一批次饲料使用情况
      tableThreeData: {
        // 饲料品类投喂集合
        fodderTypeData: [],
        // 养殖品种投喂集合
        fodderWeight: [],
      },
      // 饲料现存量数据对象
      feedChartsData: {
        ElDom: null,
        xData: [],
        yData: [],
        legend: [],
      },
      // 动保现存量数据对象
      DynamicChartsData: {
        ElDom: null,
        xData: [],
        yData: [],
        legend: [],
      },
      // 饲料日投喂数据对象
      feedDayFeedingData: {
        ElDom: null,
        xData: [],
        yData: [],
        series: [],
        legend: [],
        //为数据准备的线条颜色
        lineColor: [
          { color: "#8631F0", lineColor: "165, 92, 255" },
          { color: "#E441BE", lineColor: "253, 128, 255" },
          { color: "#6473F5", lineColor: "165, 92, 255" },
        ],
      },
      // 动保日投用图表数据对象
      DynamicData: {
        ElDom: null,
        xData: [],
        yData: [],
        series: [],
        legend: [],
        //为数据准备的线条颜色
        lineColor: [
          { color: "#8631F0", lineColor: "165, 92, 255" },
          { color: "#E441BE", lineColor: "253, 128, 255" },
          { color: "#6473F5", lineColor: "165, 92, 255" },
        ],
      },
      // 一批次各品种育苗天数与投入成本数据对象
      SeedlingDaysConstData: {
        ElDom: null,
      },
      NeedNumSpeed: true,
      // 一批次销售产值
      // OneBatchSaleData: {
      saleMoney: 0, //一批次销售产值
      saleMoneyLast: 0, //上一批次销售产值
      saleMoneyPerCent: 0, //销售产值环比
      // },
      // 一批次收获总产量
      // OneBatchHarvestData: {
      harvestYield: 0, //一批次收获总产量
      harvestYieldLast: 0, //上一批次收获总产量
      harvestYieldPerCent: 0, //收获总产量环比
      // },
      carouselData: [],
      breedEggInterval: null,
      feedUseInterval1: null,
      feedUseInterval2: null,
      fodderKgToJin: '公斤'   // 是否把公斤转换成斤
    };
  },
  computed: {},
  methods: {
    // 关闭自定义formaater
    closeFormatter(option) {
      option.baseOption &&
        option.baseOption.tooltip &&
        option.baseOption.tooltip.trigger &&
        delete option.baseOption.tooltip.trigger;
      option.baseOption &&
        option.baseOption.tooltip &&
        option.baseOption.tooltip.formatter &&
        delete option.baseOption.tooltip.formatter;
      option.tooltip &&
        option.tooltip.formatter &&
        delete option.tooltip.formatter;
      option.tooltip && option.tooltip.trigger && delete option.tooltip.trigger;
    },
    // 大屏显示图表关闭事件
    isShowChartClose() {
      // 清空图表占用 防止污染接下来注册的图表
      this.showChart.chartDom && this.showChart.chartDom.dispose();
      // 默认隐藏table的Dom实例 显示图表Dom实例
      this.isShowTable = false;
      this.showChart = {
        chartType: "",
        idName: "chart_vm",
        searchType: "",
        chartDom: null,
        unit: "",
        legend: [],
        series: [],
        xAxis: [],
        colors: [],
        targetCategory: [],
      };
    },
    // 大屏显示图表点击事件
    isShowChartClick(type, showType) {
      this.isShowChart = true;
      // this.showChart.chartType = type;
      if (type === "table-one-box") {
        this.showChart.title = "各批次饲料使用情况列表";
        this.isShowTable = true;
      } else if (type === "PrivateChatExistingCharts") {
        this.showChart.title = "饲料现存量";
        this.tangkouChartsInit2(this.showChart.idName, true);
      } else if (type === "SaveDynamicProtectionCharts") {
        this.showChart.title = "动保现存量";
        this.SaveDynamicProtectionChartsInit(this.showChart.idName, true);
      } else if (type === "DailyFeedCharts") {
        this.showChart.title = "饲料日投喂";
        this.PrivateChatChartsInit(this.showChart.idName, true);
      } else if (type === "dayDynamicProtectionCharts") {
        this.showChart.title = "动保日投用";
        this.PrivateChatChartsInit2(this.showChart.idName, true);
      }
    },
    // 一批次各品种收获情况table数据初始化
    getOneBatchBreedList() {
      service
        .getBreedPageList({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "egg",
        })
        .then((res) => {
          this.tableOneData = res.data;
        })
        .catch((err) => console.log(err));
    },
    // 一批次各品种投卵情况table数据初始化
    getTwoBarchBreedList() {
      service
        .getThrowEggPageList({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "egg",
        })
        .then((res) => {
          this.tableTwoData = res.data;
          this.tableTwoData[0].seedlingDataName = "合计";
        })
        .catch((err) => console.log(err));
    },
    // 一批次饲料使用情况table数据初始化
    getThreeBarchBreedList() {
      service
        .getFeedPageList({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "egg",
        })
        .then((res) => {
          let num = 0;
          if (res.data["fodderTypeData"]) {
            res.data["fodderTypeData"].forEach((item) => {
              num = Page.numAdd(num, item.fodderWeight);
            });
          }
          this.tableThreeData.fodderTypeData = res.data.fodderTypeData;
          this.tableThreeData.fodderWeight = res.data.fodderWeightData;
          this.UseOfABatchOfFeedNum = num;
        })
        .catch((err) => console.log(err));
    },
    // 饲料现存量柱状图初始化
    tangkouChartsInit2(ref, showBol) {
      if (!showBol) {
        this.feedChartsData.ElDom && this.feedChartsData.ElDom.dispose();
      }
      service
        .getMdtFodderDataGroupByChart({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
        })
        .then((res) => {
          const xDataList = [];
          const yDataList = [];
          if (res.data[0]) {
            this.feedChartsData.legend = [res.data[0].legendName];
            const ResArr = res.data[0].dataList;
            ResArr.map((item) => {
              xDataList.push(item.xAxisName);
              yDataList.push(item.yAxisValue);
            });
            this.feedChartsData.xData = xDataList;
            this.feedChartsData.yData = yDataList;
          }
          // 柱状
          let option = {
            // backgroundColor: "#1E1E2B", //背景颜色
            tooltip: {
              trigger: "axis",
              color: "red",
              // formatter: '{b0}<br />收获塘口数: {c0}',
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  dataStr += `<div>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color} 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data}</span>
          </div>
        </div>`;
                });
                return dataStr;
              },
              padding: [10, 10, 10, 10], //提示内边距
            },
            grid: {
              top: showBol ? "7%" : "5%",
              left: "5%",
              right: "5%",
              bottom: "15%",
              containLabel: true,
            },
            legend: {
              data: this.feedChartsData.legend,
              itemWidth: 8,
              itemHeight: 8,
              left: "10%",
              // left: "center",
              bottom: "5%",
              textStyle: {
                fontSize: showBol ? 14 : 12, //字体大小
                color: "#9BA7BF", //字体颜色
              },
            },
            xAxis: {
              type: "category",
              top: 10,
              axisTick: false, // 坐标轴小标记，默认为true
              axisLabel: {
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                  fontFamily: "Microsoft YaHei",
                },
                // x轴文字倾斜
                interval: 0,
                rotate: showBol ? 0 : 60,
              },
              axisLine: {
                lineStyle: {
                  color: "#46494A",
                },
              },
              data: this.feedChartsData.xData,
            },
            yAxis: {
              type: "value",
              splitLine: {
                lineStyle: {
                  type: [10, 10],
                  color: "#46494A",
                  width: 1,
                },
              },
            },
            series: [
              {
                name: "库存量",
                type: "bar",
                data: this.feedChartsData.yData,
                barWidth: showBol ? "10" : "8",
                label: {
                  show: showBol ? true : false,
                  fontSize: 12,
                  color: "#ffffff",
                  position: "top",
                  formatter: (params) => {
                    if (params.value == 0) {
                      return ``;
                    }
                    return params.value; //随便写的值
                  },
                },
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#907BFE" },
                    // { offset: 0.5, color: "#5442FF" },
                    { offset: 1, color: "#5442FF" },
                  ]),
                  barBorderRadius: [30, 30, 30, 30], //圆角大小
                },
              },
            ],
          };
          let myChart = $echarts.init(this.$refs[ref]);
          if (showBol) {
            this.showChart.chartDom = myChart;
            this.closeFormatter(option);
          }
          this.feedChartsData.ElDom = myChart;
          myChart.setOption(option);
        });
    },
    // 一批次各品种育苗天数与投入成本双X轴柱状图初始化
    dateCostChartsInit(ref) {
      service
        .getMdtHarvestAnalysisOrgByChart({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "egg",
        })
        .then((res) => {
          this.SeedlingDaysConstData.ElDom &&
            this.SeedlingDaysConstData.ElDom.dispose();
          const data = res.data;
          if (res.data[0]) {
            let xData = res.data[0].dataList.map((item) => {
              return item.xAxisName;
            });
            let leftData = []; //育苗天数data
            let rightData = []; //累计投入成本data
            data.forEach((item) => {
              if (item.legendName === "养殖天数") {
                leftData = item.dataList.map((item) => {
                  return item.yAxisValue;
                });
              }
              if (item.legendName === "累计成本投入") {
                rightData = item.dataList.map((item) => {
                  return item.yAxisValue;
                });
              }
            });
            var timeLineData = [1];
            var background = "#1E1E2B"; //背景
            let textColor = "#838DA1"; //文字颜色
            let lineColor = "#46494A";
            let colors = [
              {
                borderColor: "rgba(227,161,96,1)",
                start: "rgba(241, 97, 246, 1)",
                end: "rgba(178, 31, 183, 1)",
              },
              {
                borderColor: "rgba(0,222,255,1)",
                start: "rgba(84, 66, 255, 1)",
                end: "rgba(144, 123, 254, 1)",
              },
            ];
            let borderData = [];
            let scale = 2;
            var option = {
              baseOption: {
                backgroundColor: background,
                timeline: {
                  show: false,
                  top: 0,
                  data: [],
                },
                grid: [
                  {
                    show: false,
                    left: "4%",
                    top: "5%",
                    bottom: "8%",
                    containLabel: true,
                    width: "37%",
                  },
                  {
                    show: false,
                    left: "51%",
                    top: "5%",
                    bottom: "14%",
                    width: "0%",
                  },
                  {
                    show: false,
                    right: "4%",
                    top: "5%",
                    bottom: "8%",
                    containLabel: true,
                    width: "37.6%",
                  },
                ],
                tooltip: {
                  trigger: "item",
                  formatter: (params) => {
                    return `
            <div>
            <p style="text-align:center;margin-bottom:5px;">${params.name}(${
                      params.seriesName
                    })</p>
            <p><span style="margin-right:5px;border-radius:2px;display:inline-block;width:8px;height:8px;background:${
              params.seriesName === "养殖天数" ? "#F161F6" : "#5442FF"
            };"></span>数值:${params.value}</p>
            </div>`;
                  },
                },
                xAxis: [
                  {
                    type: "value",
                    inverse: true,
                    axisLine: {
                      show: false,
                    },
                    axisTick: {
                      show: false,
                    },
                    position: "bottom",
                    axisLabel: {
                      show: true,
                      color: textColor,
                    },
                    splitLine: {
                      show: true,
                      lineStyle: {
                        color: lineColor,
                      },
                    },
                  },
                  {
                    gridIndex: 1,
                    show: false,
                  },
                  {
                    gridIndex: 2,
                    axisLine: {
                      show: false,
                    },
                    axisTick: {
                      show: false,
                    },
                    position: "bottom",
                    axisLabel: {
                      show: true,
                      color: textColor,
                    },
                    splitLine: {
                      show: true,
                      lineStyle: {
                        color: lineColor,
                      },
                    },
                  },
                ],
                yAxis: [
                  {
                    type: "category",
                    inverse: true,
                    position: "right",
                    axisLine: {
                      show: true,
                      lineStyle: {
                        color: lineColor,
                      },
                    },

                    axisTick: {
                      show: false,
                    },
                    axisLabel: {
                      show: false,
                    },
                    data: xData,
                  },
                  {
                    gridIndex: 1,
                    type: "category",
                    inverse: true,
                    position: "left",
                    axisLine: {
                      show: false,
                    },
                    axisTick: {
                      show: false,
                    },
                    axisLabel: {
                      show: true,
                      padding: [30, 30, 30, 30],
                      textStyle: {
                        color: "#838DA1",
                        fontSize: 12,
                      },
                      align: "center",
                    },
                    data: xData.map(function (value) {
                      return {
                        value: value,
                        textStyle: {
                          align: "center",
                        },
                      };
                    }),
                  },
                  {
                    gridIndex: 2,
                    type: "category",
                    inverse: true,
                    position: "left",
                    axisLine: {
                      show: true,
                      lineStyle: {
                        color: lineColor,
                      },
                    },
                    axisTick: {
                      show: false,
                    },
                    axisLabel: {
                      show: false,
                    },
                    data: xData,
                  },
                ],
                series: [],
              },
              options: [],
            };
            option.options.push({
              series: [
                {
                  name: "养殖天数",
                  type: "bar",
                  barWidth: 8,
                  stack: "1",
                  itemStyle: {
                    normal: {
                      barBorderRadius: 10,
                      color: new $echarts.graphic.LinearGradient(0, 0, 1, 0, [
                        {
                          offset: 0,
                          color: colors[0].start,
                        },
                        {
                          offset: 1,
                          color: colors[0].end,
                        },
                      ]),
                    },
                  },
                  label: {
                    normal: {
                      show: true,
                      position: "left",
                      textStyle: { color: "white" },
                    },
                  },
                  data: leftData,
                  animationEasing: "elasticOut",
                },
                {
                  name: "累积投入成本",
                  type: "bar",
                  stack: "2",
                  barWidth: 8,
                  xAxisIndex: 2,
                  yAxisIndex: 2,
                  itemStyle: {
                    normal: {
                      barBorderRadius: 10,
                      color: new $echarts.graphic.LinearGradient(0, 0, 1, 0, [
                        {
                          offset: 0,
                          color: colors[1].start,
                        },
                        {
                          offset: 1,
                          color: colors[1].end,
                        },
                      ]),
                    },
                  },
                  label: {
                    normal: {
                      show: true,
                      position: "right",
                      textStyle: { color: "white" },
                    },
                  },
                  data: rightData,
                  animationEasing: "elasticOut",
                },
              ],
            });
            let myChart = $echarts.init(this.$refs[ref]);
            this.SeedlingDaysConstData.ElDom = myChart;
            myChart.setOption(option);
          }
        })
        .catch((err) => console.log(err));
    },
    // 饲料日投喂初始化函数
    PrivateChatChartsInit(ref, showBol) {
      if (!showBol) {
        this.feedDayFeedingData.ElDom &&
          this.feedDayFeedingData.ElDom.dispose();
      }
      service
        .getPrivateChatCharts({
          orgId: localStorage.getItem("orgId"),
          breedTypeClass: "egg",
          day: this.date,
        })
        .then((r) => {
          let num = 0;
          const res = r.data;
          const legendList = [];
          const xDataList = []; //准备的x轴对象
          const dataSeries = []; //准备的series
          if (res[0]) {
            // 根据数据动态生成series数量
            res[0].dataList.forEach((item, index) => {
              xDataList.push(item.xAxisName);
            });
            this.feedDayFeedingData.xData = xDataList;
            res.forEach((item, index) => {
              item.dataList.forEach((item) => {
                if (item.xAxisName === this.date) {
                  num = Page.numAdd(num, item.yAxisValue);
                }
              });
              dataSeries.push({
                name: item.legendName,
                data: [],
              });
            });
            this.DailyFeedNum = num;

            // 推入legend 计算每行数据
            for (let i = 0; i < res.length; i++) {
              legendList.push(res[i].legendName);
              if (res[i].legendName === dataSeries[i].name) {
                res[i].dataList.forEach((item) => {
                  dataSeries[i].data.push(item.yAxisValue);
                });
              }
            }
            this.feedDayFeedingData.legend = legendList;
            dataSeries.forEach((item, index) => {
              if (index > 2) {
                this.feedDayFeedingData.lineColor.push({
                  color: this.$color.randex(),
                  lineColor: this.$color.handleColorsTwo(),
                });
              }
              (item.name = item.name),
                (item.data = item.data),
                (item.symbolSize = 0), //折线点的大小
                (item.itemStyle = {
                  normal: {
                    color: this.feedDayFeedingData.lineColor[index].color,
                    lineStyle: {
                      width: 2, //设置线条粗细
                    },
                  },
                }),
                (item.areaStyle = {
                  //区域填充样式
                  normal: {
                    //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: `rgba(${this.feedDayFeedingData.lineColor[index].lineColor}, 0.1)`,
                      },
                      {
                        offset: 0.1,
                        color: `rgba(${this.feedDayFeedingData.lineColor[index].lineColor}, 0.3)`,
                      },
                      {
                        offset: 0.7,
                        color: `rgba(${this.feedDayFeedingData.lineColor[index].lineColor}, 0)`,
                      },
                    ]),
                  },
                }),
                (item.type = showBol ? "bar" : "line"),
                (item.smooth = true);
              item.label = {
                show: showBol ? true : false,
                fontSize: 12,
                // textStyle:{
                //   color:"red",
                //   fontSize:16
                // },
                color: "white",
                position: "top",
                distance: "10",
                formatter: (params) => {
                  return params.value; //随便写的值
                },
              };
            });
            this.feedDayFeedingData.series = dataSeries;
          }

          let option = {
            grid: {
              top: "20%",
              left: "12%",
              right: "5%",
            },
            // backgroundColor: "#1E1E2B", //背景颜色
            legend: {
              icon: "roundRect",
              textStyle: {
                fontSize: 12, //字体大小
                color: "#9BA7BF", //字体颜色
              },
              left: "10%",
              itemWidth: 8,
              itemHeight: 8,
              // 自定义icon
              // icon: "path://M78.625,93.094L66.494,72.081l12.132-21.013h24.264l12.132,21.013l-12.132,21.013H78.625z M95.547,80.377l4.79-8.296  l-4.79-8.296h-9.579l-4.79,8.296l4.79,8.296H95.547z",
              data: this.feedDayFeedingData.legend,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                lineStyle: {
                  type: "line",
                  width: "1",
                  color: "#46494A",
                },
              },
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  dataStr += `<div>
            <div style="margin: 0 6px;">
              <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
              ">
              <svg class="icon"  style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:${item.color};"/></svg>
              </span>
              <span>${item.seriesName}</span>
              <span style="float:right;color:#000000;margin-left:20px;">${item.data}</span>
            </div>
          </div>`;
                });
                return dataStr;
              },
            },
            dataZoom: [
              {
                bottom: "20",
                right: "35",
                left: "60",
                height: "6",
                type: "slider", //图表下方的伸缩条
                show: true, //是否显示
                start: 0, //伸缩条开始位置（1-100），可以随时更改
                end: 100, //伸缩条结束位置（1-100），可以随时更改
                dataBackground: {
                  //未选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                selectedDataBackground: {
                  //选中部分数据阴影样式
                  lineStyle: {
                    opacity: 0,
                  },
                  areaStyle: {
                    opacity: 0,
                  },
                },
                // textStyle:false,
                showDetail: false,
                height: "6",
                borderColor: "#383848", //缩放条边框颜色
                fillerColor: "#383848", //选中的阴影填充背景颜色
                handleSize: "14",
                handleStyle: {
                  color: "#48485A",
                  borderWidth: "0", //去除缩放手柄描边
                },
                // 自定义缩放手柄图标
                handleIcon:
                  "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5M36.9,35.8h-1.3z M27.8,35.8 h-1.3H27L27.8,35.8L27.8,35.8z",
                moveHandleSize: "0", //拖拽手柄尺寸大小
                moveHandleStyle: {
                  borderMiterLimit: 10,
                },
              },
            ],
            xAxis: {
              type: "category",
              data: this.feedDayFeedingData.xData,
              axisTick: {
                show: false,
              },
              axisLabel: {
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                  fontFamily: "Microsoft YaHei",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#46494A",
                },
              },
            },
            yAxis: {
              type: "value",
              splitLine: {
                lineStyle: {
                  type: [10, 10],
                  color: "#46494A",
                  width: 1,
                },
              },
            },
            series: this.feedDayFeedingData.series,
          };
          if (showBol) {
            option.dataZoom[0].maxValueSpan = 10; //区域内最多片段数据显示量
            option.dataZoom[0].zoomLock = true; //固定只能拖动不能缩放
            option.dataZoom[0].brushSelect = false; //禁用十字拖拽
          }
          let myChart = $echarts.init(this.$refs[ref]);
          if (showBol) {
            this.showChart.chartDom = myChart;
            this.closeFormatter(option);
          }
          this.feedDayFeedingData.ElDom = myChart;
          myChart.setOption(option);
        });
    },
    // 动保日投用初始化函数
    PrivateChatChartsInit2(ref, showBol) {
      if (!showBol) {
        this.DynamicData.ElDom && this.DynamicData.ElDom.dispose();
      }
      service
        .getDynamicCharts({
          orgId: localStorage.getItem("orgId"),
          breedTypeClass: "egg",
          day: this.date,
        })
        .then((r) => {
          let num = 0;
          const res = r.data;
          const xDataList = [];
          const legendList = [];
          const dataSeries = [];
          if (res[0]) {
            // 根据数据动态生成series数量
            res[0].dataList.forEach((item, index) => {
              xDataList.push(item.xAxisName);
            });
            res.forEach((item, index) => {
              item.dataList.forEach((item) => {
                if (item.xAxisName === this.date) {
                  num = Page.numAdd(num, item.yAxisValue);
                }
              });
              dataSeries.push({
                name: item.legendName,
                data: [],
              });
            });
            this.DailyBasisNum = num;

            // 推入legend 计算每行数据
            for (let i = 0; i < res.length; i++) {
              legendList.push(res[i].legendName);
              if (res[i].legendName === dataSeries[i].name) {
                res[i].dataList.forEach((item) => {
                  dataSeries[i].data.push(item.yAxisValue);
                });
              }
            }
            dataSeries.forEach((item, index) => {
              if (index > 2) {
                this.DynamicData.lineColor.push({
                  color: this.$color.randex(),
                  lineColor: this.$color.handleColorsTwo(),
                });
              }
              (item.name = item.name),
                (item.data = item.data),
                (item.symbolSize = 0), //折线点的大小
                (item.itemStyle = {
                  normal: {
                    color: this.DynamicData.lineColor[index].color,
                    lineStyle: {
                      width: 2, //设置线条粗细
                    },
                  },
                }),
                (item.areaStyle = {
                  //区域填充样式
                  normal: {
                    //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                    color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: `rgba(${this.DynamicData.lineColor[index].lineColor}, 0.1)`,
                      },
                      {
                        offset: 0.1,
                        color: `rgba(${this.DynamicData.lineColor[index].lineColor}, 0.3)`,
                      },
                      {
                        offset: 0.7,
                        color: `rgba(${this.DynamicData.lineColor[index].lineColor}, 0)`,
                      },
                    ]),
                  },
                }),
                (item.type = showBol ? "bar" : "line"),
                (item.smooth = true);
              item.label = {
                show: showBol ? true : false,
                fontSize: 12,
                // textStyle:{
                //   color:"red",
                //   fontSize:16
                // },
                color: "white",
                position: "top",
                distance: "10",
                formatter: (params) => {
                  return params.value; //随便写的值
                },
              };
            });
            this.DynamicData.series = dataSeries;
            this.DynamicData.xData = xDataList;
            this.DynamicData.legend = legendList;
            let option = {
              grid: {
                top: "20%",
                left: "12%",
                right: "5%",
              },
              // backgroundColor: "#1E1E2B", //背景颜色
              legend: {
                icon: "roundRect",
                textStyle: {
                  fontSize: 12, //字体大小
                  color: "#9BA7BF", //字体颜色
                },
                left: "10%",
                itemWidth: 8,
                itemHeight: 8,
                // 自定义icon
                // icon: "path://M78.625,93.094L66.494,72.081l12.132-21.013h24.264l12.132,21.013l-12.132,21.013H78.625z M95.547,80.377l4.79-8.296  l-4.79-8.296h-9.579l-4.79,8.296l4.79,8.296H95.547z",
                data: this.DynamicData.legend,
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  lineStyle: {
                    type: "line",
                    width: "1",
                    color: "#46494A",
                  },
                },
                formatter: (params) => {
                  let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                  params.forEach((item, i) => {
                    dataStr += `<div>
            <div style="margin: 0 6px;">
              <span style="display:inline-block;position:relative;width:8px;margin-right:5px;
              ">
              <svg class="icon"  style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:${item.color};"/></svg>
              </span>
              <span>${item.seriesName}</span>
              <span style="float:right;color:#000000;margin-left:20px;">${item.data}</span>
            </div>
          </div>`;
                  });
                  return dataStr;
                },
              },
              dataZoom: [
                {
                  bottom: "20",
                  right: "35",
                  left: "60",
                  height: "6",
                  type: "slider", //图表下方的伸缩条
                  show: true, //是否显示
                  start: 0, //伸缩条开始位置（1-100），可以随时更改
                  end: 100, //伸缩条结束位置（1-100），可以随时更改
                  dataBackground: {
                    //未选中部分数据阴影样式
                    lineStyle: {
                      opacity: 0,
                    },
                    areaStyle: {
                      opacity: 0,
                    },
                  },
                  selectedDataBackground: {
                    //选中部分数据阴影样式
                    lineStyle: {
                      opacity: 0,
                    },
                    areaStyle: {
                      opacity: 0,
                    },
                  },
                  // textStyle:false,
                  showDetail: false,
                  height: "6",
                  borderColor: "#383848", //缩放条边框颜色
                  fillerColor: "#383848", //选中的阴影填充背景颜色
                  handleSize: "14",
                  handleStyle: {
                    color: "#48485A",
                    borderWidth: "0", //去除缩放手柄描边
                  },
                  // 自定义缩放手柄图标
                  handleIcon:
                    "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5M36.9,35.8h-1.3z M27.8,35.8 h-1.3H27L27.8,35.8L27.8,35.8z",
                  moveHandleSize: "0", //拖拽手柄尺寸大小
                  moveHandleStyle: {
                    borderMiterLimit: 10,
                  },
                },
              ],
              xAxis: {
                type: "category",
                data: this.DynamicData.xData,
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  textStyle: {
                    color: "#838DA1",
                    fontSize: 12,
                    fontFamily: "Microsoft YaHei",
                  },
                },
                axisLine: {
                  lineStyle: {
                    color: "#46494A",
                  },
                },
              },
              yAxis: {
                type: "value",
                splitLine: {
                  lineStyle: {
                    type: [10, 10],
                    color: "#46494A",
                    width: 1,
                  },
                },
              },
              series: this.DynamicData.series,
            };
            if (showBol) {
              option.dataZoom[0].maxValueSpan = 3; //区域内最多片段数据显示量
              option.dataZoom[0].zoomLock = true; //固定只能拖动不能缩放
              option.dataZoom[0].brushSelect = false; //禁用十字拖拽
            }
            let myChart = $echarts.init(this.$refs[ref]);
            if (showBol) {
              this.showChart.chartDom = myChart;
              this.closeFormatter(option);
            }
            this.DynamicData.ElDom = myChart;
            myChart.setOption(option);
          }
        });
    },
    // 动保现存量初始化
    SaveDynamicProtectionChartsInit(ref, showBol) {
      if (!showBol) {
        this.DynamicChartsData.ElDom && this.DynamicChartsData.ElDom.dispose();
      }
      this.DynamicChartsData = {
        xData: [],
        yData: [],
        legend: [],
      };
      service
        .DynamicGetChatrs({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
        })
        .then((res) => {
          const xDataList = [];
          const yDataList = [];
          if (res.data[0]) {
            this.DynamicChartsData.legend = [res.data[0].legendName];
            const ResArr = res.data[0].dataList;
            ResArr.map((item) => {
              xDataList.push(item.xAxisName);
              yDataList.push(item.yAxisValue);
            });
            this.DynamicChartsData.xData = xDataList;
            this.DynamicChartsData.yData = yDataList;
          }
          // 柱状
          let option = {
            // backgroundColor: "#1E1E2B", //背景颜色
            tooltip: {
              trigger: "axis",
              color: "red",
              // formatter: '{b0}<br />收获塘口数: {c0}',
              formatter: (params) => {
                let dataStr = `<div><p style="font-weight:bold;margin:0 8px 10px;">${params[0].name}</p></div>`;
                params.forEach((item, i) => {
                  dataStr += `<div>
          <div style="margin: 0 8px;">
            <span style="display:inline-block;margin-right:4px;width:8px;height:8px;border-radius:2px;background:linear-gradient(0deg, ${item.color.colorStops[0].color} 0%, ${item.color.colorStops[1].color} 100%);"></span>
            <span>${item.seriesName}</span>
            <span style="float:right;color:#000000;margin-left:20px;">${item.data}</span>
          </div>
        </div>`;
                });
                return dataStr;
              },
              padding: [10, 10, 10, 10], //提示内边距
            },
            grid: {
              top: showBol ? "7%" : "5%",
              left: "5%",
              right: "5%",
              bottom: "15%",
              containLabel: true,
            },
            legend: {
              data: this.DynamicChartsData.legend,
              itemWidth: 8,
              itemHeight: 8,
              left: "10%",
              // left: "center",
              bottom: "5%",
              textStyle: {
                fontSize: showBol ? 14 : 12, //字体大小
                color: "#9BA7BF", //字体颜色
              },
            },
            xAxis: {
              type: "category",
              top: 10,
              axisTick: false, // 坐标轴小标记，默认为true
              axisLabel: {
                textStyle: {
                  color: "#838DA1",
                  fontSize: 12,
                  fontFamily: "Microsoft YaHei",
                },
                // x轴文字倾斜
                interval: 0,
                rotate: showBol ? 0 : 60,
              },
              axisLine: {
                lineStyle: {
                  color: "#46494A",
                },
              },
              data: this.DynamicChartsData.xData,
            },
            yAxis: {
              type: "value",
              splitLine: {
                lineStyle: {
                  type: [10, 10],
                  color: "#46494A",
                  width: 1,
                },
              },
            },
            series: [
              {
                name: "库存金额",
                type: "bar",
                // data: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                data: this.DynamicChartsData.yData,
                barWidth: showBol ? "10" : "8",
                label: {
                  show: showBol ? true : false,
                  fontSize: 12,
                  color: "#ffffff",
                  position: "top",
                  formatter: (params) => {
                    if (params.value == 0) {
                      return ``;
                    }
                    return params.value; //随便写的值
                  },
                },
                itemStyle: {
                  color: new $echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#907BFE" },
                    // { offset: 0.5, color: "#5442FF" },
                    { offset: 1, color: "#5442FF" },
                  ]),
                  barBorderRadius: [30, 30, 30, 30], //圆角大小
                },
              },
            ],
          };
          let myChart = $echarts.init(this.$refs[ref]);
          if (showBol) {
            this.showChart.chartDom = myChart;
            this.closeFormatter(option);
          }
          this.DynamicChartsData.ElDom = myChart;
          myChart.setOption(option);
        });
    },
    // 获取一批次销售产值、一批次收获总产量
    getOrgForTargetValue() {
      service
        .searchMdtHarvestAnalysisOrgForTargetValue({
          orgId: localStorage.getItem("orgId"),
          day: this.date,
          breedTypeClass: "egg",
        })
        .then((res) => {
          this.saleMoney = res.data.saleMoney;
          this.saleMoneyLast = res.data.saleMoneyLast;
          this.saleMoneyPerCent = res.data.saleMoneyPerCent;
          this.harvestYield = res.data.harvestYield;
          this.harvestYieldLast = res.data.harvestYieldLast;
          this.harvestYieldPerCent = res.data.harvestYieldPerCent;
          this.carouselData = res.data;
        })
        .catch((err) => console.log(err, "1446"));
    },
    breedEggScroll() {
      const table = this.$refs.breedEggTable;
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      const timeTop = setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 1;
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
          clearInterval(timeTop);
          setTimeout(() => {
            divData.scrollTop = 0;
          }, 5460);
        }
        if (divData.scrollTop % 46 === 0) {
          clearInterval(timeTop);
        }
      }, 10); // 滚动速度
    },
    clearBreedEggScroll() {
      clearInterval(this.breedEggInterval);
    },
    setBreedEggScroll() {
      this.breedEggInterval = setInterval(this.breedEggScroll, 5460);
    },
    feedUseScroll1() {
      const table = this.$refs.feedUseTable1;
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      const timeTop = setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 1;
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
          clearInterval(timeTop);
          setTimeout(() => {
            divData.scrollTop = 0;
          }, 5690);
        }
        if (divData.scrollTop % 69 === 0) {
          clearInterval(timeTop);
        }
      }, 10); // 滚动速度
    },
    clearFeedUseScroll1() {
      clearInterval(this.feedUseInterval1);
    },
    setFeedUseScroll1() {
      this.feedUseInterval1 = setInterval(this.feedUseScroll1, 5690);
    },
    feedUseScroll2() {
      const table = this.$refs.feedUseTable2;
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      const timeTop = setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 1;
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
          clearInterval(timeTop);
          setTimeout(() => {
            divData.scrollTop = 0;
          }, 5690);
        }
        if (divData.scrollTop % 69 === 0) {
          clearInterval(timeTop);
        }
      }, 10); // 滚动速度
    },
    clearFeedUseScroll2() {
      clearInterval(this.feedUseInterval2);
    },
    setFeedUseScroll2() {
      this.feedUseInterval2 = setInterval(this.feedUseScroll2, 5690);
    },
  },
  mounted() {
    this.breedEggInterval = setInterval(this.breedEggScroll, 5460);
    this.feedUseInterval1 = setInterval(this.feedUseScroll1, 5690);
    this.feedUseInterval2 = setInterval(this.feedUseScroll2, 5690);
    let reg2 = new RegExp(/^\d{4}\-\d{2}\-\d{2}$/);
    // 正则验证 当时间格式为yyyy-MM-DD时才会初始化图表
    if (!reg2.test(this.date)) {
      return;
    }
    // 一批次各品种收获情况
    this.getOneBatchBreedList();
    // 一批次各品种投卵情况
    this.getTwoBarchBreedList();
    // 一批次饲料使用情况
    this.getThreeBarchBreedList();
    // 饲料日投喂charts初始化
    this.PrivateChatChartsInit("PrivateChatCharts");
    // 动保日投用
    this.PrivateChatChartsInit2("dayDynamicProtectionCharts");
    // 饲料现存量charts初始化
    this.tangkouChartsInit2("PrivateChatExistingCharts");
    // 动保现存量
    this.SaveDynamicProtectionChartsInit("SaveDynamicProtectionCharts");
    // 一批次各品种育苗天数与投入成本charts初始化
    this.dateCostChartsInit("dateCostCharts");
    // 获取一批次销售产值、一批次收获总产量
    this.getOrgForTargetValue();
  },
  beforeDestroy() {
    clearInterval(this.breedEggInterval);
    clearInterval(this.feedUseInterval1);
    clearInterval(this.feedUseInterval2);
  },
  created() {
    // 获取是否公斤转换成斤
    listParamStatus(this.orgId, ['fodderKgToJin']).then((res) => {
      if (res.code == "0000") {
        this.fodderKgToJin = res.data.fodderKgToJin === true ? '斤' : '公斤';
      }
    })
    // 监听浏览器窗口页面
    window.addEventListener("resize", () => {
      debounce(
        () => {
          // this.annalsTarget.chartDom && this.annalsTarget.chartDom.resize();
          // this.put.chartDom && this.put.chartDom.resize();
          // this.storage.chartDom && this.storage.chartDom.resize();
          // this.sales.chartDom && this.sales.chartDom.resize();
          // this.prefix.chartDom && this.prefix.chartDom.resize();
          // this.cost.chartDom && this.cost.chartDom.resize();
          // this.harvest.chartDom && this.harvest.chartDom.resize();
          // this.quota.chartDom && this.quota.chartDom.resize();
        },
        100,
        false
      );
    });
  },
  // 数据监听
  watch: {
    dateType: function (value) {
      // console.log(value, "监听日期类型");
      // this.type = value == "year" ? "Y" : "M";
    },
    date: function (value, old) {
      let reg2 = new RegExp(/^\d{4}\-\d{2}\-\d{2}$/);
      // 正则验证 当时间格式为yyyy-MM-DD时才会初始化图表
      if (!reg2.test(value)) {
        return;
      }
      // 一批次各品种育苗天数与投入成本charts初始化
      this.dateCostChartsInit("dateCostCharts");
      // 饲料日投喂charts初始化
      this.PrivateChatChartsInit("PrivateChatCharts");
      // 动保日投用
      this.PrivateChatChartsInit2("dayDynamicProtectionCharts");
      // 饲料现存量charts初始化
      this.tangkouChartsInit2("PrivateChatExistingCharts");
      // 动保现存量
      this.SaveDynamicProtectionChartsInit("SaveDynamicProtectionCharts");
      // 一批次各品种收货情况
      this.getOneBatchBreedList();
      // 一批次各品种投卵情况
      this.getTwoBarchBreedList();
      // 获取一批次销售产值、一批次收获总产量
      this.getOrgForTargetValue();
      // 一批次饲料使用情况
      this.getThreeBarchBreedList();
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  width: 100%;
  min-height: 939px;
  // height: 100%;
  // height: auto;
  overflow-y: auto;
  display: flex;
  background: #181a1f;
  // 布局样式
  > div {
    // 去除左右两边外间距和盒子的外间距
    width: calc((100% - 21px) / 2);
    margin-top: 7px;
    margin-left: 7px;
  }
  .left-box {
    flex-direction: column;
    box-sizing: border-box;
    display: flex;

    .top-box {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      height: 136px;
      .el-carousel {
        width: 100%;
        padding: 0;
        /deep/ .el-carousel__container {
          .el-carousel__arrow--left {
            left: 0;
          }
          .el-carousel__arrow--right {
            right: 0;
          }
          .el-carousel__item {
            display: flex;
            justify-content: space-between;
            > div {
              box-sizing: border-box;
              width: calc((100% - 7px) / 2);
              background: #5442ff;
              font-size: 20px;
              padding: 13px 0px 13px 0px;
              > div {
                align-items: center;
                display: flex;
                height: 100%;

                .text {
                  flex-direction: column;
                  display: flex;
                  width: 59%;
                  text-align: center;
                  font-size: 14px;
                  height: 100%;
                  font-family: DINCond-Black;
                  font-weight: 400;

                  p:nth-child(1) {
                    margin-top: 6px;
                    height: 25px;
                    display: inline-block;

                    img {
                      height: 100%;
                    }
                  }

                  p:nth-child(2) {
                    display: inline-block;

                    span {
                      margin-top: 1px;
                    }
                  }

                  p:nth-child(3) {
                    margin-top: 3px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    font-size: 14px;
                    color: #ffffff;
                  }
                }

                .num-text {
                  box-sizing: border-box;
                  border-left: 2px solid #432ffc;
                  flex: 1;
                  width: 41%;
                  height: 100%;
                  font-size: 13px;
                  display: flex;
                  flex-direction: column;
                  color: #fbfbff;
                  font-family: DINCond-Black;
                  font-weight: 400;

                  div:nth-child(1) {
                    width: 100%;
                    display: inline-block;
                    height: 50%;

                    p:nth-child(1) {
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      text-align: center;
                    }

                    p:nth-child(2) {
                      text-align: center;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      span:first-child {
                        font-size: 24px;
                      }

                      span:last-child {
                        position: relative;
                        display: inline-block;

                        img {
                          top: -20px;
                          position: absolute;
                        }
                      }
                    }
                  }

                  div:nth-child(2) {
                    margin-top: 16px;
                    width: 100%;
                    display: inline-block;
                    height: 50%;

                    p:nth-child(1) {
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      text-align: center;
                    }

                    p:nth-child(2) {
                      text-align: center;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      span:first-child {
                        font-size: 24px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .center-box {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      height: 383px;
      margin-top: 7px;
      box-sizing: border-box;
      > div {
        width: 100%;
        height: 100%;
        display: flex;
        background: pink;
        flex-direction: column;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;
        box-sizing: border-box;

        div:first-child {
          margin-top: 22px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }
        }

        /deep/.right-center-table {
          box-sizing: border-box;
          padding-left: 35px;
          padding-right: 25px;
          display: flex;
          width: 100%;
          height: 100%;

          // el-table样式改变
          .el-table {
            margin-top: unset;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            background: #1e1e2b;
            border-color: #46494a;
          }

          .el-table__cell.gutter {
            display: none;
          }
          ::-webkit-scrollbar-corner {
            display: none;
          }

          ::-webkit-scrollbar-track-piece {
            //滚动条凹槽的颜色，还可以设置边框属性
            //滚动条剩余部分的背景颜色
            background-color: #1e1e2b;
          }

          ::-webkit-scrollbar {
            //滚动条整体的宽度
            width: 6px;
            height: 6px;
          }

          ::-webkit-scrollbar-thumb {
            //滚动条小点的设置
            background-color: #48485a;
            background-clip: padding-box;
            min-height: 28px;
            border-radius: 8px;
          }

          // ::-webkit-scrollbar-thumb:hover {
          //   background-color: #a8a8a8;
          // }

          // 滚动条的宽度
          /deep/ .el-table__body-wrapper::-webkit-scrollbar {
            width: 2px; // 横向滚动条
            height: 2px; // 纵向滚动条 必写
          }
          // 滚动条的滑块
          /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
            background-color: #ddd;
            border-radius: 3px;
          }

          .el-table__header {
            color: red;
          }

          .el-table::before {
            display: none;
            // background: #46494a;
          }

          .el-table td.el-table__cell {
            border-color: #46494a;
          }

          .el-table .el-table__cell {
            padding: 11px 0px !important;
          }

          .el-table .cell {
            text-align: center;
            // white-space: nowrap;
          }

          .el-table th.el-table__cell > .cell {
            overflow: unset;
            white-space: nowrap;
          }

          .el-table tbody tr:hover > td {
            background: #1e1e2b !important;
          }

          .el-table tr {
            background: #1e1e2b;
          }

          .table-one-box {
            display: flex;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            padding: 0px 10px 20px 0px;
          }

          /deep/ .table-two-box {
            display: flex;
            width: 50%;
            height: 100%;
          }
        }

        .el-table__cell.gutter {
          display: none;
        }
        ::-webkit-scrollbar-corner {
          display: none;
        }

        ::-webkit-scrollbar-track-piece {
          //滚动条凹槽的颜色，还可以设置边框属性
          //滚动条剩余部分的背景颜色
          background-color: #1e1e2b;
        }

        ::-webkit-scrollbar {
          //滚动条整体的宽度
          width: 6px;
          height: 6px;
        }

        ::-webkit-scrollbar-thumb {
          //滚动条小点的设置
          background-color: #48485a;
          background-clip: padding-box;
          min-height: 28px;
          border-radius: 8px;
        }

        // ::-webkit-scrollbar-thumb:hover {
        //   background-color: #a8a8a8;
        // }

        // 滚动条的宽度
        /deep/ .el-table__body-wrapper::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        // 滚动条的滑块
        /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
          background-color: #48485a;
          background-clip: padding-box;
          min-height: 28px;
          border-radius: 8px;
        }

        .el-table__header {
          color: red;
        }

        .el-table::before {
          display: none;
          // background: #46494a;
        }

        .el-table td.el-table__cell {
          border-color: #46494a;
        }

        .el-table .el-table__cell {
          padding: 11px 0px !important;
        }

        .el-table .cell {
          text-align: center;
          // white-space: nowrap;
        }

        .el-table th.el-table__cell > .cell {
          overflow: unset;
          white-space: nowrap;
        }

        .el-table tbody tr:hover > td {
          background: #1e1e2b !important;
        }

        .el-table tr {
          background: #1e1e2b;
        }

        .table-one-box {
          display: flex;
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          padding: 0px 10px 20px 0px;
        }

        div:last-child {
          margin-top: unset;
          margin-left: unset;
          width: 100%;
          height: 100%;
        }
      }
    }

    .bottom-box {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      height: 390px;
      margin-top: 9px;

      .two-box {
        display: flex;
        flex-direction: column;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;

        div:first-child {
          position: relative;
          margin-top: 22px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }

          /deep/.check {
            white-space: nowrap;
            cursor: pointer;
            position: absolute;
            right: 23px;
            bottom: 3px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d7d7d9;

            .route-target {
              margin-bottom: -3px;
              margin-right: 23px;
              width: unset;

              .check {
                background: unset;
              }
            }

            i {
              font-size: 13px;
            }
          }
        }

        div:last-child {
          padding-top: 20px;
          width: 100%;
          height: 100%;
        }
      }

      .two-box {
        width: 100%;
      }
    }
  }
  .right-box {
    flex-direction: column;
    box-sizing: border-box;
    display: flex;

    > div {
      margin-top: 7px;
      // 去除左右两边外间距和盒子的外间距
      width: 100%;
      height: 303.67px;

      &:first-child {
        margin-top: 0;
      }
    }

    .top-box {
      display: flex;
      > div {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        // 去除左右两边外间距和盒子的外间距
        width: calc(100% / 2 - 3.5px);
        margin-right: 7px;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;
        // display: flex;
        // flex-direction: column;
        // // 去除左右两边外间距和盒子的外间距
        // width: calc(100% / 2);
        // // margin-right: 16px;
        // background: #1e1e2b;
        // border: 1px solid #2e2d3e;

        &:last-child {
          margin-right: unset;
        }

        div:first-child {
          margin-top: 16px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }
        }

        /deep/.table-box {
          box-sizing: border-box;
          display: flex;
          width: 100%;
          height: 100%;
          .table-two-box:nth-child(1) {
            .el-table {
              padding-right: 10px;
              .el-table__body-wrapper {
                padding-right: 10px !important;
              }
            }
          }

          // el-table样式改变
          .el-table {
            margin-top: 5px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            background: #1e1e2b;
            border-color: #46494a;
          }

          .el-table__cell.gutter {
            display: none;
          }
          ::-webkit-scrollbar-corner {
            display: none;
          }

          ::-webkit-scrollbar-track-piece {
            //滚动条凹槽的颜色，还可以设置边框属性
            //滚动条剩余部分的背景颜色
            background-color: #1e1e2b;
          }

          ::-webkit-scrollbar {
            //滚动条整体的宽度
            width: 6px;
            height: 6px;
          }

          ::-webkit-scrollbar-thumb {
            //滚动条小点的设置
            background-color: #48485a;
            background-clip: padding-box;
            min-height: 28px;
            border-radius: 8px;
          }

          // ::-webkit-scrollbar-thumb:hover {
          //   background-color: #a8a8a8;
          // }

          // 滚动条的宽度
          /deep/ .el-table__body-wrapper::-webkit-scrollbar {
            width: 2px; // 横向滚动条
            height: 2px; // 纵向滚动条 必写
          }
          // 滚动条的滑块
          /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
            background-color: #ddd;
            border-radius: 3px;
          }

          .el-table__header {
            color: red;
          }

          .el-table::before {
            display: none;
            // background: #46494a;
          }

          .el-table td.el-table__cell {
            border-color: #46494a;
          }

          .el-table .el-table__cell {
            padding: 11px 0px !important;
          }

          .el-table .cell {
            text-align: center;
            // white-space: nowrap;
          }

          .el-table th.el-table__cell > .cell {
            overflow: unset;
            white-space: nowrap;
          }

          .el-table tbody tr:hover > td {
            background: #1e1e2b !important;
          }

          .el-table tr {
            background: #1e1e2b;
          }

          .table-one-box {
            display: flex;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            padding: 0px 10px 20px 0px;
          }

          .table-two-box {
            box-sizing: border-box;
            padding-right: 19px;
            display: flex;
            width: 50%;
            height: 100%;
          }
        }
      }
    }

    .center-box {
      display: flex;
      box-sizing: border-box;
      > div {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        // 去除左右两边外间距和盒子的外间距
        width: calc(100% / 2);
        margin-right: 7px;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;

        &:last-child {
          margin-right: unset;
        }

        div:first-child {
          position: relative;
          margin-top: 22px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }

          /deep/.check {
            white-space: nowrap;
            cursor: pointer;
            position: absolute;
            right: 23px;
            bottom: 3px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d7d7d9;

            .route-target {
              margin-bottom: -3px;
              margin-right: 23px;
              width: unset;

              .check {
                background: unset;
              }
            }

            i {
              font-size: 13px;
            }
          }
        }

        div:last-child {
          padding-top: 20px;
          width: 100%;
          height: 100%;
        }
      }
    }

    .bottom-box {
      display: flex;
      > div {
        display: flex;
        flex-direction: column;
        // 去除左右两边外间距和盒子的外间距
        width: calc(100% / 2);
        margin-right: 7px;
        background: #1e1e2b;
        border: 1px solid #2e2d3e;

        &:last-child {
          margin-right: unset;
        }

        div:first-child {
          position: relative;
          margin-top: 22px;
          margin-left: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;

          span:first-child {
            margin-right: 6px;
            display: inline-block;
            width: 4px;
            height: 17px;
            background: #8631f0;
            border-radius: 4px 0px 4px 0px;
          }

          /deep/.check {
            white-space: nowrap;
            cursor: pointer;
            position: absolute;
            right: 23px;
            bottom: 3px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d7d7d9;

            .route-target {
              margin-bottom: -3px;
              margin-right: 23px;
              width: unset;

              .check {
                background: unset;
              }
            }

            i {
              font-size: 13px;
            }
          }
        }

        div:last-child {
          padding-top: 20px;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>